<template>
  <section>
    <div class="ta-center pb-50 pt-50 bg-blue">
      <a
        href="/admin"
        class="customStartButton"
        v-if="$store.state.profile.isSigned"
      >
        {{ $t("header.t6") }}
      </a>
      <a href="#" class="customStartButton" v-else>
        {{ $t("landingPage.getStarted.buttonText") }}
      </a>
    </div>
  </section>
</template>
<script>
export default {
  name: "GetStarted",
};
</script>
